/**
 * Model definition for HighCharts
 */
export interface ContentHighCharts {
  __component: 'content.high-charts';
  id: string;
  highChartJSON?: { [key: string]: unknown };
}

export function isContentHighCharts(obj: { __component?: string }): obj is ContentHighCharts {
  return obj.__component === 'content.high-charts';
}
